import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';

const JobProgress = job => {
  if (job.pending_objects <= 0 || job.status !== 'WORKING') {
    return null;
  }

  const percentage = Math.round((1 - job.pending_objects / job.total_objects) * 100);

  return (
    <div style={{ width: 30 }}>
      <CircularProgressbar
        value={percentage}
        text={`${percentage}%`}
        styles={buildStyles({
          textSize: '2.6em',
        })}
      />
    </div>
  );
};

export default JobProgress;
